import React from 'react';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>Terms of Service - Lead Generation Agreement | Cargo Engage</title>
        <meta name="description" content="Cargo Engage terms of service. We are NOT a lender. Lead generation and marketing services agreement, information sharing authorization, and SMS program terms." />
        <meta name="keywords" content="terms of service, lead generation agreement, not a lender, SMS terms, TCPA consent, user agreement" />
      </Helmet>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Terms of Service</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <p style={{marginBottom: '2rem', fontStyle: 'italic'}}>
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div style={{background: '#fff3cd', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #ffc107'}}>
              <p style={{fontWeight: '600', color: '#856404', marginBottom: '0.5rem'}}>
                Important Disclosure:
              </p>
              <p style={{color: '#856404'}}>
                Cargo Engage is a lead generation and marketing company. We are NOT a lender and do NOT make credit decisions. 
                We connect consumers with financial service providers.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>1. Acceptance of Terms</h2>
            <p style={{marginBottom: '2rem'}}>
              By accessing or using Cargo Engage's website and services, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our services.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>2. Description of Services</h2>
            <p style={{marginBottom: '1rem'}}>
              Cargo Engage provides lead generation and marketing services for the financial services industry. Our services include:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Connecting consumers with financial service providers</li>
              <li>Lead qualification and verification</li>
              <li>SMS and email marketing services</li>
              <li>Campaign management and optimization</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>3. User Representations</h2>
            <p style={{marginBottom: '1rem'}}>By using our services, you represent and warrant that:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>You are at least 18 years of age</li>
              <li>You have the legal capacity to enter into binding contracts</li>
              <li>All information you provide is accurate and truthful</li>
              <li>You are authorized to provide the contact information submitted</li>
              <li>You understand we will share your information with lending partners</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>4. Information Sharing Authorization</h2>
            <div style={{background: '#f0f9ff', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <p style={{fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem'}}>
                By submitting your information through our website, you expressly authorize:
              </p>
              <ul style={{color: '#1e40af', paddingLeft: '1.5rem'}}>
                <li>Cargo Engage to share your contact information and inquiry with our network of financial service providers</li>
                <li>Multiple lending partners to contact you about their products and services</li>
                <li>Communication via phone, email, and SMS from Cargo Engage and our partners</li>
              </ul>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>5. SMS Terms</h2>
            <p style={{marginBottom: '1rem'}}>
              By providing your mobile phone number and consent, you agree to receive SMS messages from Cargo Engage 
              and our lending partners. Message frequency varies. Message and data rates may apply. Reply STOP to opt out.
            </p>
            <p style={{marginBottom: '2rem', fontWeight: '600', color: '#1e40af'}}>
              Your consent to receive SMS is not required as a condition of purchasing any goods or services, and is not 
              required to obtain credit.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>6. Not a Lender Disclaimer</h2>
            <div style={{background: '#fef2f2', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #ef4444'}}>
              <p style={{fontWeight: '600', color: '#dc2626', marginBottom: '0.5rem'}}>
                IMPORTANT DISCLAIMER:
              </p>
              <p style={{color: '#dc2626'}}>
                Cargo Engage is NOT a lender, loan broker, or agent for any lender or loan broker. We do NOT make credit 
                decisions, extend credit, or determine loan terms. We are a lead generation company that connects consumers 
                with financial service providers. Any financial products or services you receive will be provided by third-party 
                lenders, not by Cargo Engage.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>7. No Guarantee of Approval</h2>
            <p style={{marginBottom: '2rem'}}>
              Submitting your information through our website does NOT guarantee that you will be approved for any financial 
              product or service. Approval decisions are made solely by the lending partners we connect you with, based on 
              their own underwriting criteria.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>8. User Conduct</h2>
            <p style={{marginBottom: '1rem'}}>You agree NOT to:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Provide false or misleading information</li>
              <li>Use our services for any illegal purpose</li>
              <li>Attempt to interfere with our website or services</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Impersonate another person or entity</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>9. Limitation of Liability</h2>
            <p style={{marginBottom: '2rem'}}>
              Cargo Engage shall not be liable for any damages arising from your use of our services, including but not 
              limited to decisions made by lending partners, terms of financial products offered, or any interactions with 
              third-party service providers.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>10. Modifications to Terms</h2>
            <p style={{marginBottom: '2rem'}}>
              We reserve the right to modify these Terms of Service at any time. We will notify you of material changes 
              by posting the updated terms on our website. Your continued use of our services after such changes constitutes 
              acceptance of the modified terms.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>11. Governing Law</h2>
            <p style={{marginBottom: '2rem'}}>
              These Terms of Service are governed by the laws of the State of New York, without regard to its conflict 
              of law provisions.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>12. Contact Information</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px'}}>
              <p><strong>CARGO AUTOMOTIVE SERVICES INC</strong></p>
              <p><strong>DBA:</strong> Cargo Engage</p>
              <p>306 Schunnemunk Street<br />Monroe, NY 10950<br />United States</p>
              <p><strong>Owner:</strong> Mendel Friedman</p>
              <p><strong>EIN:</strong> 83-2229681</p>
              <p style={{marginTop: '1rem'}}><strong>Email:</strong> legal@cargoengage.com</p>
              <p><strong>Support:</strong> support@cargoengage.com</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
